import { createSelector } from 'reselect';
import teamInfoSelector from './currentSessionTeamInfo';

export default createSelector(teamInfoSelector, (teamInfo) =>
  teamInfo?.channelPreferences ? teamInfo.channelPreferences : undefined
);
